// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_ga_event.js.old'; import './autoload/_stories.js'; import './autoload/_swiper.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
// jQuery(document).ready(() => routes.loadEvents());
document.addEventListener('DOMContentLoaded', function(){
  routes.loadEvents();
});

// Navigate through entrepreneurs and entreprises
jQuery(document).ready(function ($) {
  let bounce = true
  $('.btn-scroll-down').click(function (){
    if(bounce) {
      bounce = false
      $(this).closest('.selector').find('.select-options').animate({
        scrollTop: '+=100',
      }, 400, function () {
        bounce = true
      });
    }
  });
  $('.btn-scroll-up').click(function (){
    if(bounce){
      bounce = false
      $(this).closest('.selector').find('.select-options').animate({
        scrollTop: '-=100',
      }, 400, function () {
        bounce = true
      });
    }
  });

  $('.ctaCarousel .btn ').click(function (){
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
  });

});




// WEBPACK FOOTER //
// ./scripts/main.js